import PasswordShowHide from '../../../javascripts/components/PasswordShowHide';

if (!window?.Coorum) {
  window.Coorum = {};
}
window.Coorum.PasswordShowHide = PasswordShowHide;

document.addEventListener('DOMContentLoaded', () => {
  const showHideButtons = document.querySelectorAll('.password_show_hide_icon');
  showHideButtons.forEach((element) => {
    const passShowHide = new window.Coorum.PasswordShowHide(element);
    passShowHide.setEvents();
  });
});
